<template>
  <div>
    <b-row class="mt-2">
      <b-col cols="12">
        <b-button
          variant="primary"
          type="submit"
          class="addAwaitBtn"
          @click.prevent="submitForm"
        >
          {{ $t('DEBTIA_SUBMIT') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async submitForm() {
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 22,
        module_order: 1,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      const url = '/process/module/add'
      axios.post(url, dataObj).then(response => {
        if (response.status === 200) {
          const returnObj = {
            parentID: this.conditionObject.parentID,
            depend: dataObj.depends_on,
          }
          returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
          this.$emit('closeBailiffModal', returnObj)
        }
      }).catch(e => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: e.response.data.message,
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addAwaitBtn {
    width: 100%;
  }
</style>
